import React from 'react';
import { useQuery } from 'react-fetching-library';
import { CircularProgress } from '@mui/material';
import Page from '../../components-core/Page';
import { SnackbarAlert } from '../../components-core/SnackbarAlert';
import { getClientOrdersAction } from '../../services/request';
import GroupList from '../../sections/client/groups/GroupList';

const Groups = () => {
  const [orders, setOrders] = React.useState([]);
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const { loading, payload, error } = useQuery(getClientOrdersAction());

  const handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenSnackbar(false);
  };

  React.useEffect(() => {
    if (!error && !loading) {
      console.log(payload);
      setOrders(payload);
    }
    if (error) {
      setOpenSnackbar(true);
    }
  }, [loading]);

  return (
    <Page title="Grupy">
      {loading ? <CircularProgress /> : <GroupList groups={orders}/>}
      <SnackbarAlert open={openSnackbar} severity="error" message="Wystąpił błąd" onClose={handleCloseSnackbar} />
    </Page>
  );
};


export default Groups;
